// pages/CheckinCheckout.js
import React, { useRef, useState, useEffect } from 'react';
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  Space,
  Typography,
  message,
  Tag,
  Tooltip,
  Row,
  Col,
  Popconfirm,
  Badge,
  Statistic,
  Divider,
  Card,
  DatePicker,
  Tabs,
  Switch,
  Select,
  Descriptions,
  Avatar,
  List,
  Collapse,
  InputNumber,FloatButton ,Skeleton,
  Radio
} from 'antd';
import {
  PlusOutlined,ArrowsAltOutlined,AppstoreOutlined ,LeftOutlined,RightOutlined ,DoubleLeftOutlined ,DoubleRightOutlined,
  EditOutlined,CaretLeftOutlined,CaretRightOutlined,
  DeleteOutlined,
  SearchOutlined,
  ReloadOutlined,
  EyeOutlined,
  ExportOutlined,
  PrinterOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  UserOutlined,
  HomeOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  TeamOutlined,
  KeyOutlined,
  LogoutOutlined,
  CheckOutlined,
  CloseOutlined,
  SwapOutlined,
  InfoCircleOutlined,
  FilterOutlined,
  DownloadOutlined,
  SettingOutlined
} from '@ant-design/icons';
import axios from 'axios';
// import moment from 'moment';

import dayjs from 'dayjs';

import PageContainer from '../components/PageContainer';
import { BASE_URL } from '../utils/constants';

// Importamos el componente de asignación de habitaciones
// import AsignarHabitacionModal from '../components/AsignarHabitacionModal';
import AsignacionHabitacionesDrawer from '../components/AsignacionHabitacionesDrawer';
import ModalLineas from '../components/ModalLineas';

const { Title, Text, Paragraph } = Typography;
const { TabPane } = Tabs;
const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const CheckinCheckout = () => {
  // Estados principales
  const [activeTab, setActiveTab] = useState('entradas');
  const [entradas, setEntradas] = useState([]);
  const [salidas, setSalidas] = useState([]);
  const [filteredEntradas, setFilteredEntradas] = useState([]);
  const [filteredSalidas, setFilteredSalidas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);

  const [habitacionesDisponibles, setHabitacionesDisponibles] = useState([]);
  const [cargandoHabitacionesDisponibles, setCargandoHabitacionesDisponibles] = useState(false);  
  const [lineaSeleccionadaAsignacion, setLineaSeleccionadaAsignacion] = useState(null);  
  const [cargandoAsignacion, setCargandoAsignacion] = useState(false);
  const [plantasDisponibles, setPlantasDisponibles] = useState([]);
  const [tiposHabitacionDisponibles, setTiposHabitacionDisponibles] = useState([]);
  const [currentReserva, setCurrentReserva] = useState(null);  
  const [lineasReserva, setLineasReserva] = useState([]);

  const [indiceRegistroActual, setIndiceRegistroActual] = useState(0);
  const [registrosFiltradosActuales, setRegistrosFiltradosActuales] = useState([]);
  const [modoAsignacion, setModoAsignacion] = useState('drawer'); // 'drawer' o 'modal'
  const [modalAsignacionRapidaVisible, setModalAsignacionRapidaVisible] = useState(false);  

  const [panelAsignacionVisible, setPanelAsignacionVisible] = useState(false);
  const [panelAncho, setPanelAncho] = useState(400); // Ancho inicial del panel
  const [estaRedimensionando, setEstaRedimensionando] = useState(false);
  const [panelPosicion, setPanelPosicion] = useState(0); // Para seguimiento del mouse

  const [filtroBusquedaHabitaciones, setFiltroBusquedaHabitaciones] = useState('');
  const [filtroPlanta, setFiltroPlanta] = useState(null);
  const [filtroTipo, setFiltroTipo] = useState(null);  


  // Estados para filtros
  const [fechaSeleccionada, setFechaSeleccionada] = useState(dayjs());
  const [globalSearchText, setGlobalSearchText] = useState('');
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  
  // Estados para modales
  const [modalDetalleVisible, setModalDetalleVisible] = useState(false);
  const [modalAsignarVisible, setModalAsignarVisible] = useState(false);
  const [currentRegistro, setCurrentRegistro] = useState(null);
  const [ocupantes, setOcupantes] = useState([]);

  const resizeRef = useRef(null);
  
  const [modalLineasVisible, setModalLineasVisible] = useState(false);
  const [reservaSeleccionada, setReservaSeleccionada] = useState(null);

  // Cargar datos iniciales
  useEffect(() => {
    fetchData();
  }, [fechaSeleccionada]);

useEffect(() => {
    const handleMouseMove = (e) => {
      if (!estaRedimensionando) return;
      
      const nuevoAncho = window.innerWidth - e.clientX;
      if (nuevoAncho >= 300 && nuevoAncho <= 800) {
        setPanelAncho(nuevoAncho);
      }
    };

    const handleMouseUp = () => {
      setEstaRedimensionando(false);
      document.body.style.cursor = 'default';
    };

    if (estaRedimensionando) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = 'col-resize';
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [estaRedimensionando]);  

  const fetchData = async () => {
    setTableLoading(true);
    try {
      const token = localStorage.getItem('token');
      const fechaFormateada = fechaSeleccionada.format('YYYY-MM-DD');
      
      // Cargar entradas y salidas en paralelo
      const [entradasResponse, salidasResponse] = await Promise.all([
        axios.get(`${BASE_URL}/api/checkin-checkout/entradas`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { fecha: fechaFormateada }
        }),
        axios.get(`${BASE_URL}/api/checkin-checkout/salidas`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { fecha: fechaFormateada }
        })
      ]);
      
      setEntradas(entradasResponse.data.data || []);
      setFilteredEntradas(entradasResponse.data.data || []);
      setSalidas(salidasResponse.data.data || []);
      setFilteredSalidas(salidasResponse.data.data || []);          
      
    } catch (error) {
      message.error('Error al cargar los datos');
      console.error('Error fetchData:', error);
    } finally {
      setTableLoading(false);
    }
  };

  const abrirModalLineas = (record) => {

    
    setReservaSeleccionada({
      numReserva: record.numreserva,
      linea: record.linea,
      nombre: record.nombre
    });
    setModalLineasVisible(true);
  };


  const abrirPanelAsignacion = async (record) => {
    // console.log("Abrir panel de asignación para:", record);
    
    // Determinar qué registros mostrar según la pestaña activa
    const registrosActivos = activeTab === 'entradas' ? filteredEntradas : filteredSalidas;
    const registrosParaNavegar = registrosActivos.filter(r => 
      !r.numhab2 || r.numhab2 === '' || r.numhab2 === null
    );
    
    setRegistrosFiltradosActuales(registrosParaNavegar);
    
    // Encontrar el índice del registro actual
    const indice = registrosParaNavegar.findIndex(r => 
      r.numreserva === record.numreserva && r.linea === record.linea
    );
    
    setIndiceRegistroActual(indice >= 0 ? indice : 0);
    
    // Cargar el registro
    await cargarRegistroParaAsignacion(record);
    
    // Mostrar el panel
    setPanelAsignacionVisible(true);
  };


  // Función para checkin masivo
const handleCheckinMasivo = async () => {
  try {
    setLoading(true);
    const token = localStorage.getItem('token');
    
    // Filtrar solo las líneas con habitación asignada y sin checkin
    const lineasParaCheckin = filteredEntradas.filter(r => r.numhab2 && !r.entro);
    
    if (lineasParaCheckin.length === 0) {
      message.warning('No hay líneas con habitación asignada pendientes de checkin');
      return;
    }
    
    // Realizar checkin para cada línea
    const promises = lineasParaCheckin.map(record => 
      axios.post(
        `${BASE_URL}/api/checkin-checkout/checkin`,
        {
          numReserva: record.numreserva,
          linea: record.linea,
          aplicarATodaHabitacion: true,
          valor: 1
        },
        { headers: { Authorization: `Bearer ${token}` } }
      )
    );
    
    await Promise.all(promises);
    
    message.success(`Checkin realizado a ${lineasParaCheckin.length} líneas`);
    
    // Actualizar datos
    await fetchData();
    
  } catch (error) {
    console.error('Error en checkin masivo:', error);
    message.error(error.response?.data?.error || 'Error al realizar checkin masivo');
  } finally {
    setLoading(false);
  }
};

// Función para checkout masivo
const handleCheckoutMasivo = async () => {
  try {
    setLoading(true);
    const token = localStorage.getItem('token');
    
    // Filtrar solo las líneas sin checkout
    const lineasParaCheckout = filteredSalidas.filter(r => !r.salio);
    
    if (lineasParaCheckout.length === 0) {
      message.warning('No hay líneas pendientes de checkout');
      return;
    }
    
    // Realizar checkout para cada línea
    const promises = lineasParaCheckout.map(record => 
      axios.post(
        `${BASE_URL}/api/checkin-checkout/checkout`,
        {
          numReserva: record.numreserva,
          linea: record.linea,
          aplicarATodaHabitacion: true
        },
        { headers: { Authorization: `Bearer ${token}` } }
      )
    );
    
    await Promise.all(promises);
    
    message.success(`Checkout realizado a ${lineasParaCheckout.length} líneas`);
    
    // Actualizar datos
    await fetchData();
    
  } catch (error) {
    console.error('Error en checkout masivo:', error);
    message.error(error.response?.data?.error || 'Error al realizar checkout masivo');
  } finally {
    setLoading(false);
  }
};


const navegarRegistro = (direccion) => {
    if (!registrosFiltradosActuales.length) return;
    
    let nuevoIndice = indiceRegistroActual;
    
    if (direccion === 'siguiente') {
      nuevoIndice = (indiceRegistroActual + 1) % registrosFiltradosActuales.length;
    } else if (direccion === 'anterior') {
      nuevoIndice = indiceRegistroActual === 0 
        ? registrosFiltradosActuales.length - 1 
        : indiceRegistroActual - 1;
    }
    
    setIndiceRegistroActual(nuevoIndice);
    cargarRegistroParaAsignacion(registrosFiltradosActuales[nuevoIndice]);
  };

  // Función para búsqueda global
  const handleGlobalSearch = (searchText) => {
    setGlobalSearchText(searchText);
    
    if (!searchText.trim()) {
      setFilteredEntradas(entradas);
      setFilteredSalidas(salidas);
      return;
    }
    
    const lowerSearchText = searchText.toLowerCase().trim();
    
    const filterData = (data) => {
      return data.filter(record => {
        return Object.keys(record).some(key => {
          const value = record[key];
          if (value === null || value === undefined) return false;
          return String(value).toLowerCase().includes(lowerSearchText);
        });
      });
    };
    
    setFilteredEntradas(filterData(entradas));
    setFilteredSalidas(filterData(salidas));
  };

  // Función para obtener el estado del checkin
  const getEstadoCheckin = (entro) => {
    return entro === true ? (
      <Badge status="success" text="Checkin Realizado" />
    ) : (
      <Badge status="warning" text="Pendiente" />
    );
  };

  // Función para obtener el estado del checkout
  const getEstadoCheckout = (salio) => {
    return salio === true ? (
      <Badge status="success" text="Checkout Realizado" />
    ) : (
      <Badge status="warning" text="Pendiente" />
    );
  };

  // Función para obtener el tipo de habitación
  const getTipoHabDesc = (tipoHab) => {
    switch(tipoHab) {
      case 'IN': return { text: 'Individual', color: 'blue' };
      case 'DO': return { text: 'Doble', color: 'green' };
      case 'TR': return { text: 'Triple', color: 'orange' };
      case 'CU': return { text: 'Cuádruple', color: 'purple' };
      case 'QU': return { text: 'Quintuple', color: 'red' };
      default: return { text: tipoHab, color: 'default' };
    }
  };

  // Función para obtener el tipo de facturación
  const getTipoFacDesc = (tipoFac) => {
    switch(tipoFac) {
      case 'IN': return 'Individual';
      case 'DO': return 'Doble';
      case 'TR': return 'Triple';
      case 'AD1': return 'Adulto 1';
      case 'AD2': return 'Adulto 2';
      case 'NI1': return 'Niño 1';
      case 'NI2': return 'Niño 2';
      case 'NIE': return 'Niño Especial';
      case 'BB': return 'Bebé';
      default: return tipoFac;
    }
  };

 const accionesColumna = (record) => (
    <Space>
      {/* Botón Checkin/Checkout según pestaña */}
      {activeTab === 'entradas' ? (
        record.entro === false ? (
          // <Popconfirm
          //   title="¿Realizar checkin?"
          //   onConfirm={() => handleCheckin(record,1)}
          //   okText="Sí"
          //   cancelText="No"
          // >
            <Tooltip title="Realizar checkin">
              <Button
                type="primary"
                icon={<CheckCircleOutlined />}
                size="small"
                onClick={() => handleCheckin(record,1)}
                disabled={!record.numhab}
              >
                Checkin
              </Button>
            </Tooltip>
          // </Popconfirm>
        ) : (
          <Tooltip title="Checkin ya realizado">
            <Button
              type="default"
              icon={<CheckCircleOutlined />}
              size="small"
              onClick={() => handleCheckin(record,0)}
              // disabled
            >
              Hecho
            </Button>
          </Tooltip>
        )
      ) : (
        record.salio === false ? (
          <Popconfirm
            title="¿Realizar checkout?"
            onConfirm={() => handleCheckout(record)}
            okText="Sí"
            cancelText="No"
          >
            <Tooltip title="Realizar checkout">
              <Button
                type="primary"
                danger
                icon={<LogoutOutlined />}
                size="small"
              >
                Checkout
              </Button>
            </Tooltip>
          </Popconfirm>
        ) : (
          <Tooltip title="Checkout ya realizado">
            <Button
              type="default"
              icon={<LogoutOutlined />}
              size="small"
              disabled
            >
              Hecho
            </Button>
          </Tooltip>
        )
      )}
      
      {/* Botón Asignar Habitación */}
      <Tooltip title="Asignar habitación">
        <Button
          type={record.numhab2 ? "default" : "dashed"}
          icon={<KeyOutlined />}
          size="small"
          onClick={() => abrirPanelAsignacion(record)}
        >
          {record.numhab2 ? `Hab: ${record.numhab2}` : 'Asignar'}
        </Button>
      </Tooltip>

      {/* <Tooltip title="Asignar habitación">
        <Button
          type={record.numhab2 ? "default" : "dashed"}
          icon={<KeyOutlined />}
          size="small"
          onClick={() => abrirDrawerAsignacion(record)}
        >
          {record.numhab2 ? `Hab: ${record.numhab2}` : 'Asignar'}
        </Button>
      </Tooltip>       */}
      
      {/* Botón Ver Detalle */}
      {/* <Tooltip title="Ver detalle">
        <Button
          type="text"
          icon={<EyeOutlined />}
          size="small"
          onClick={() => handleVerDetalle(record)}
        />
      </Tooltip> */}
    </Space>
  );

  // Columnas para entradas
  const columnasEntradas = [
    {
      title: 'Ocupantes',
      key: 'ocupantes',
      width: 100,
      render: (_, record) => (
        <Tooltip title="Ver ocupantes de la habitación">
          <Button
            type="text"
            icon={<TeamOutlined />}
            onClick={() => abrirModalLineas(record)}
          >
            {record.numocupantes || 'Ver'}
          </Button>
        </Tooltip>
      )
    },
    {
      title: 'Nº Reserva',
      dataIndex: 'numreserva',
      key: 'numreserva',
      width: 100,
      sorter: (a, b) => a.numreserva - b.numreserva,
      render: (numReserva) => (
        <Tag color="blue" style={{ fontWeight: 'bold' }}>
          #{numReserva}
        </Tag>
      ),
    },
    {
      title: 'Línea',
      dataIndex: 'linea',
      key: 'linea',
      width: 80,
    },
    {
      title: 'Habitación',
      dataIndex: 'numhab2',
      key: 'numhab2',
      width: 100,
      render: (numhab) => (
        numhab ? (
          <Tag color="green" icon={<HomeOutlined />}>
            {numhab}
          </Tag>
        ) : (
          <Tag color="orange" icon={<HomeOutlined />}>
            Sin asignar
          </Tag>
        )
      ),
    },
    {
      title: 'Checkin',
      dataIndex: 'entro',
      key: 'entro',
      width: 120,
      render: (entro) => getEstadoCheckin(entro),
    },
    {
      title: 'Fecha Salida',
      dataIndex: 'salida',
      key: 'salida',
      width: 120,
      render: (salida) => dayjs(salida).format('DD/MM/YYYY'),
    },
    {
      title: 'Tipo Hab.',
      dataIndex: 'tipohab',
      key: 'tipohab',
      width: 100,
      render: (tipohab) => {
        const tipo = getTipoHabDesc(tipohab);
        return <Tag color={tipo.color}>{tipo.text}</Tag>;
      },
    },
    {
      title: 'Nombre',
      dataIndex: 'nombre',
      key: 'nombre',
      width: 200,
      ellipsis: true,
    },
    {
      title: 'Agencia',
      dataIndex: 'nomagencia',
      key: 'nomagencia',
      width: 150,
      ellipsis: true,
    },
    {
      title: 'Régimen',
      dataIndex: 'regimen',
      key: 'regimen',
      width: 100,
    },
    {
      title: 'Localizador',
      dataIndex: 'snumero',
      key: 'snumero',
      width: 120,
      render: (snumero) => snumero || '-',
    },
    // {
    //   title: 'Acciones',
    //   key: 'acciones',
    //   width: 200,
    //   fixed: 'right',
    //   render: (_, record) => (
    //     <Space>
    //       {/* Botón Checkin */}
    //       {record.entro === 0 ? (
    //         <Popconfirm
    //           title="¿Realizar checkin?"
    //           description="¿Confirmar checkin para esta habitación?"
    //           onConfirm={() => handleCheckin(record)}
    //           okText="Sí"
    //           cancelText="No"
    //         >
    //           <Tooltip title="Realizar checkin">
    //             <Button
    //               type="primary"
    //               icon={<CheckCircleOutlined />}
    //               size="small"
    //             >
    //               Checkin
    //             </Button>
    //           </Tooltip>
    //         </Popconfirm>
    //       ) : (
    //         <Tooltip title="Checkin ya realizado">
    //           <Button
    //             type="default"
    //             icon={<CheckCircleOutlined />}
    //             size="small"
    //             disabled
    //           >
    //             Hecho
    //           </Button>
    //         </Tooltip>
    //       )}
          
    //       {/* Botón Asignar Habitación */}
    //       {/* {(!record.numhab2 || record.numhab2 === '') && ( */}
    //         <Tooltip title="Asignar habitación">
    //           <Button
    //             type="dashed"
    //             icon={<KeyOutlined />}
    //             size="small"
    //             onClick={() => abrirDrawerAsignacion(record)}
    //           >
    //             Asignar
    //           </Button>
    //         </Tooltip>
    //       {/* )} */}
          
    //       {/* Botón Ver Detalle */}
    //       <Tooltip title="Ver detalle">
    //         <Button
    //           type="text"
    //           icon={<EyeOutlined />}
    //           size="small"
    //           onClick={() => handleVerDetalle(record)}
    //         />
    //       </Tooltip>
    //     </Space>
    //   ),
    //},
        {
      title: 'Acciones',
      key: 'acciones',
      width: 200,
      fixed: 'right',
      render: (_, record) => accionesColumna(record),
    },
  ];

  // Columnas para salidas
  const columnasSalidas = [
    {
      title: 'Nº Reserva',
      dataIndex: 'numreserva',
      key: 'numreserva',
      width: 100,
      sorter: (a, b) => a.numreserva - b.numreserva,
      render: (numReserva) => (
        <Tag color="blue" style={{ fontWeight: 'bold' }}>
          #{numReserva}
        </Tag>
      ),
    },
    {
      title: 'Línea',
      dataIndex: 'linea',
      key: 'linea',
      width: 80,
    },
    {
      title: 'Habitación',
      dataIndex: 'numhab2',
      key: 'numhab2',
      width: 100,
      render: (numhab) => (
        numhab ? (
          <Tag color="green" icon={<HomeOutlined />}>
            {numhab}
          </Tag>
        ) : (
          <Tag color="orange" icon={<HomeOutlined />}>
            Sin asignar
          </Tag>
        )
      ),
    },
    {
      title: 'Checkout',
      dataIndex: 'salio',
      key: 'salio',
      width: 120,
      render: (salio) => getEstadoCheckout(salio),
    },
    {
      title: 'Fecha Entrada',
      dataIndex: 'entrada',
      key: 'entrada',
      width: 120,
      render: (entrada) => dayjs(entrada).format('DD/MM/YYYY'),
    },
    {
      title: 'Tipo Hab.',
      dataIndex: 'tipohab',
      key: 'tipohab',
      width: 100,
      render: (tipohab) => {
        const tipo = getTipoHabDesc(tipohab);
        return <Tag color={tipo.color}>{tipo.text}</Tag>;
      },
    },
    {
      title: 'Nombre',
      dataIndex: 'nombre',
      key: 'nombre',
      width: 200,
      ellipsis: true,
    },
    {
      title: 'Agencia',
      dataIndex: 'nomagencia',
      key: 'nomagencia',
      width: 150,
      ellipsis: true,
    },
    {
      title: 'Régimen',
      dataIndex: 'regimen',
      key: 'regimen',
      width: 100,
    },
    {
      title: 'Localizador',
      dataIndex: 'snumero',
      key: 'snumero',
      width: 120,
      render: (snumero) => snumero || '-',
    },
    // {
    //   title: 'Acciones',
    //   key: 'acciones',
    //   width: 200,
    //   fixed: 'right',
    //   render: (_, record) => (
    //     <Space>
    //       {/* Botón Checkout */}
    //       {record.salio === 0 ? (
    //         <Popconfirm
    //           title="¿Realizar checkout?"
    //           description="¿Confirmar checkout para esta habitación?"
    //           onConfirm={() => handleCheckout(record)}
    //           okText="Sí"
    //           cancelText="No"
    //         >
    //           <Tooltip title="Realizar checkout">
    //             <Button
    //               type="primary"
    //               danger
    //               icon={<LogoutOutlined />}
    //               size="small"
    //             >
    //               Checkout
    //             </Button>
    //           </Tooltip>
    //         </Popconfirm>
    //       ) : (
    //         <Tooltip title="Checkout ya realizado">
    //           <Button
    //             type="default"
    //             icon={<LogoutOutlined />}
    //             size="small"
    //             disabled
    //           >
    //             Hecho
    //           </Button>
    //         </Tooltip>
    //       )}
          
    //       {/* Botón Ver Detalle */}
    //       <Tooltip title="Ver detalle">
    //         <Button
    //           type="text"
    //           icon={<EyeOutlined />}
    //           size="small"
    //           onClick={() => handleVerDetalle(record)}
    //         />
    //       </Tooltip>
    //     </Space>
    //   ),
    // },
       {
      title: 'Acciones',
      key: 'acciones',
      width: 250,
      fixed: 'right',
      render: (_, record) => accionesColumna(record),
    },
  ];



    const cerrarModalAsignacionRapida = () => {
    setModalAsignacionRapidaVisible(false);
    // Si había drawer abierto, también lo cerramos
    if (modalAsignarVisible) {
      setModalAsignarVisible(false);
    }
  };

    const asignarYContinuar = async (numHabitacion) => {
    await asignarHabitacion(numHabitacion);
    
    // Si hay más registros, avanzar al siguiente
    if (registrosFiltradosActuales.length > 1) {
      setTimeout(() => {
        navegarRegistro('siguiente');
      }, 500);
    }
  };

  const NavegacionRegistros = () => {
    if (!registrosFiltradosActuales.length) return null;
    
    const totalRegistros = registrosFiltradosActuales.length;
    const registroActual = registrosFiltradosActuales[indiceRegistroActual];
    
    return (
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        marginBottom: 16,
        padding: '12px',
        backgroundColor: '#fafafa',
        borderRadius: '8px',
        border: '1px solid #f0f0f0'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Button
            icon={<LeftOutlined />}
            size="small"
            onClick={() => navegarRegistro('anterior')}
            disabled={totalRegistros <= 1}
          />
          
          <Text strong style={{ minWidth: '150px' }}>
            Registro {indiceRegistroActual + 1} de {totalRegistros}
          </Text>
          
          <Button
            icon={<RightOutlined />}
            size="small"
            onClick={() => navegarRegistro('siguiente')}
            disabled={totalRegistros <= 1}
          />
        </div>
        
        <div style={{ textAlign: 'right' }}>
          <Text type="secondary">
            Reserva: <Tag color="blue">#{registroActual?.numreserva}</Tag>
            Línea: <Tag color="blue">{registroActual?.linea}</Tag>
          </Text>
        </div>
      </div>
    );
  };

  const renderModalAsignacionRapida = () => (
    <Modal
      title={
        <Space>
          <KeyOutlined />
          <span>Asignación Rápida de Habitaciones</span>
        </Space>
      }
      open={modalAsignacionRapidaVisible}
      onCancel={cerrarModalAsignacionRapida}
      width={900}
      footer={[
        <Button 
          key="drawer" 
          icon={<ArrowsAltOutlined />}
          onClick={() => {
            setModalAsignacionRapidaVisible(false);
            abrirDrawerAsignacion(registrosFiltradosActuales[indiceRegistroActual], 'drawer');
          }}
        >
          Abrir vista detallada
        </Button>,
        <Button key="close" onClick={cerrarModalAsignacionRapida}>
          Cerrar
        </Button>
      ]}
    >
      {/* Navegación entre registros */}
      <NavegacionRegistros />
      
      {/* Información de la reserva actual */}
      {lineaSeleccionadaAsignacion && currentReserva && (
        <Card size="small" style={{ marginBottom: 16 }}>
          <Descriptions size="small" column={3}>
            <Descriptions.Item label="Cliente">
              <Text strong>{currentReserva.Nombre}</Text>
            </Descriptions.Item>
            <Descriptions.Item label="Agencia">
              {currentReserva.nomagencia || 'Directa'}
            </Descriptions.Item>
            <Descriptions.Item label="Estancia">
              {dayjs(lineaSeleccionadaAsignacion.Entrada).format('DD/MM/YYYY')} - {dayjs(lineaSeleccionadaAsignacion.Salida).format('DD/MM/YYYY')}
            </Descriptions.Item>
            <Descriptions.Item label="Tipo Habitación">
              <Tag color={getTipoHabDesc(lineaSeleccionadaAsignacion.TipoHab).color}>
                {getTipoHabDesc(lineaSeleccionadaAsignacion.TipoHab).text}
              </Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Habitación Actual">
              {lineaSeleccionadaAsignacion.NumHab ? (
                <Tag color="green">{lineaSeleccionadaAsignacion.NumHab}</Tag>
              ) : (
                <Tag color="orange">Sin asignar</Tag>
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Régimen">
              {lineaSeleccionadaAsignacion.Regimen}
            </Descriptions.Item>
          </Descriptions>
        </Card>
      )}
      
      {/* Habitaciones disponibles */}
      <div style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
          <Text strong>Habitaciones Disponibles ({habitacionesDisponibles.length})</Text>
          <Text type="secondary">
            {cargandoHabitacionesDisponibles ? 'Cargando...' : 'Listado actualizado'}
          </Text>
        </div>
        
        {cargandoHabitacionesDisponibles ? (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <Text type="secondary">Cargando habitaciones disponibles...</Text>
          </div>
        ) : habitacionesDisponibles.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '20px', backgroundColor: '#fff8e1', borderRadius: '8px' }}>
            <Text type="warning">No hay habitaciones disponibles para estas fechas</Text>
          </div>
        ) : (
          <Row gutter={[8, 8]}>
            {habitacionesDisponibles.slice(0, 20).map(habitacion => (
              <Col span={6} key={habitacion.numhabitacio || habitacion.NumHab}>
                <Card
                  size="small"
                  hoverable
                  style={{
                    textAlign: 'center',
                    cursor: 'pointer',
                    borderColor: habitacion.disponible ? '#d9d9d9' : '#ffa39e',
                    backgroundColor: habitacion.disponible ? '#ffffff' : '#fff2f0'
                  }}
                  onClick={() => habitacion.disponible && asignarYContinuar(habitacion.numhabitacio || habitacion.NumHab)}
                >
                  <div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '4px' }}>
                    {habitacion.numhabitacio || habitacion.NumHab}
                  </div>
                  <div style={{ fontSize: '12px', color: '#666' }}>
                    Planta: {habitacion.planta || 'N/A'}
                  </div>
                  <div style={{ fontSize: '12px', color: '#666', marginBottom: '8px' }}>
                    {habitacion.tipo || 'Standard'}
                  </div>
                  {habitacion.disponible ? (
                    <Tag color="success">Disponible</Tag>
                  ) : (
                    <Tag color="error">Ocupada</Tag>
                  )}
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </div>
      
      {/* Botón para desasignar si ya tiene habitación */}
      {lineaSeleccionadaAsignacion?.NumHab && (
        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <Popconfirm
            title="¿Desasignar habitación?"
            description="Esta acción liberará la habitación actual"
            onConfirm={desasignarHabitacion}
            okText="Sí"
            cancelText="No"
          >
            <Button danger icon={<CloseOutlined />}>
              Desasignar Habitación {lineaSeleccionadaAsignacion.NumHab}
            </Button>
          </Popconfirm>
        </div>
      )}
    </Modal>
  );

  const renderFloatButton = () => (
    <FloatButton.Group
      shape="square"
      style={{ right: 24 }}
      icon={<SettingOutlined />}
    >
      <FloatButton
        icon={<AppstoreOutlined />}
        tooltip="Modo asignación rápida"
        onClick={() => setModoAsignacion('modal')}
      />
      <FloatButton
        icon={<ArrowsAltOutlined />}
        tooltip="Modo vista detallada"
        onClick={() => setModoAsignacion('drawer')}
      />
    </FloatButton.Group>
  );

  // Handlers para las acciones
  const handleCheckin = async (record,valor) => {
    try {
      // console.log(" handleCheckin => ",valor);
      
      setLoading(true);
      const token = localStorage.getItem('token');
      
      await axios.post(
        `${BASE_URL}/api/checkin-checkout/checkin`,
        {
          numReserva: record.numreserva,
          linea: record.linea,
          aplicarATodaHabitacion: true,
          valor: valor
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      record.entro === false
          ? message.success('Checkin realizado correctamente')
          : message.success('Checkin quitado correctamente')   
      
      
      // Actualizar datos
      await fetchData();
      
    } catch (error) {
      console.error('Error en checkin:', error);
      message.error(error.response?.data?.error || 'Error al realizar checkin');
    } finally {
      setLoading(false);
    }
  };

  const handleCheckout = async (record) => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      
      await axios.post(
        `${BASE_URL}/api/checkin-checkout/checkout`,
        {
          numReserva: record.numreserva,
          linea: record.linea,
          aplicarATodaHabitacion: true
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      message.success('Checkout realizado correctamente');
      
      // Actualizar datos
      await fetchData();
      
    } catch (error) {
      console.error('Error en checkout:', error);
      message.error(error.response?.data?.error || 'Error al realizar checkout');
    } finally {
      setLoading(false);
    }
  };

  const handleAsignarHabitacion = (record) => {
    setCurrentRegistro(record);
    setModalAsignarVisible(true);
  };

  const handleVerDetalle = async (record) => {
    try {
      setLoading(true);
      setCurrentRegistro(record);
      
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${BASE_URL}/api/checkin-checkout/${record.numreserva}/lineas/${record.linea}/ocupantes`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      setOcupantes(response.data.data || []);
      setModalDetalleVisible(true);
      
    } catch (error) {
      console.error('Error obteniendo detalle:', error);
      message.error('Error al cargar el detalle');
    } finally {
      setLoading(false);
    }
  };

const abrirDrawerAsignacion = async (record) => {
    // console.log(" record => ", record);
    
    const token = localStorage.getItem('token');
    
    try {
        // Obtener datos de la reserva
        const response = await axios.get(
            `${BASE_URL}/api/reservas/${record.numreserva}`,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        
        const reserva = response.data.data.cabecera;
        // console.log(" Reserva => ", reserva);

        // Obtener datos de la línea específica
        const responseLineas = await axios.get(
            `${BASE_URL}/api/reservas/${record.numreserva}/lineas/${record.linea}`,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        
        const reservaLineas = responseLineas.data.data[0];
        // console.log(" reservaLineas => ", reservaLineas);
        
        // Establecer ambos estados y luego cargar habitaciones
        setCurrentReserva(reserva);
        setLineaSeleccionadaAsignacion(reservaLineas);
        setModalAsignarVisible(true);
        setLineasReserva(responseLineas.data.data);
        
        // Pasar ambos parámetros a la función
        cargarHabitacionesDisponibles(reservaLineas, reserva);
        
    } catch (error) {
        console.error('Error al obtener datos de la reserva:', error);
        message.error('Error al cargar datos de la reserva');
    }
};

  // Nueva función para cargar un registro específico
const cargarRegistroParaAsignacion = async (record) => {
    if (!record) return;
    
    const token = localStorage.getItem('token');
    
    try {
      // Obtener datos de la reserva
      const response = await axios.get(
        `${BASE_URL}/api/reservas/${record.numreserva}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      const reserva = response.data.data.cabecera;

      // Obtener datos de la línea específica
      const responseLineas = await axios.get(
        `${BASE_URL}/api/reservas/${record.numreserva}/lineas/${record.linea}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      const reservaLineas = responseLineas.data.data[0];
      
      // Establecer estados
      setCurrentReserva(reserva);
      setLineaSeleccionadaAsignacion(reservaLineas);
      setLineasReserva(responseLineas.data.data);
      
      // Cargar habitaciones disponibles
      await cargarHabitacionesDisponibles(reservaLineas, reserva);
      
    } catch (error) {
      console.error('Error al obtener datos de la reserva:', error);
      message.error('Error al cargar datos de la reserva');
    }
  };

const cargarHabitacionesDisponibles = async (linea, reserva) => {
    // console.log("Cargando habitaciones para:", linea);
    
    if (!linea) {
      // console.log("Línea no definida");
      message.error("No se pudo obtener información de la línea");
      return;
    }
    
    setCargandoHabitacionesDisponibles(true);
    setFiltroBusquedaHabitaciones('');
    setFiltroPlanta(null);
    setFiltroTipo(null);
    
    try {
      const token = localStorage.getItem('token');
      const entrada = dayjs(linea.Entrada).format('YYYY-MM-DD');
      const salida = dayjs(linea.Salida).format('YYYY-MM-DD');
      
      const params = new URLSearchParams({
        entrada: entrada,
        salida: salida,
        excluirReserva: linea.NumReserva || (reserva ? reserva.NumReserva : null),
      });

      if (linea.TipoHab) {
        const mapaTipos = {
          'IN': 'INDIVIDUAL',
          'DO': 'DOBLE', 
          'TR': 'TRIPLE',
          'CU': 'CUADRUPLE',
          'QU': 'QUINTUPLE'
        };
        
        const tipoHabFiltro = mapaTipos[linea.TipoHab] || linea.TipoHab;
        params.append('tipoHab', tipoHabFiltro);
      }
      
      const url = `${BASE_URL}/api/reservas/disponibles/habitaciones?${params.toString()}`;
      
      // console.log("URL de consulta:", url);
      
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.data.success) {
        const habitaciones = response.data.data || [];
        
        let habitacionesParaMostrar = habitaciones.map(h => ({
          ...h,
          numhabitacio: h.numhab || h.numhabitacio || h.NumHab,
          tipo: h.descrip || h.tipo || 'Standard',
          planta: h.planta || Math.floor((h.numhab || h.numhabitacio || h.NumHab || 0) / 100),
          disponible: h.disponible !== false
        }));
        
        setHabitacionesDisponibles(habitacionesParaMostrar);
        
        const plantas = [...new Set(habitacionesParaMostrar.map(h => 
          h.planta || Math.floor((h.numhab || h.numhabitacio || h.NumHab || 0) / 100)
        ))].filter(planta => planta !== undefined && planta !== null).sort((a, b) => a - b);
        
        setPlantasDisponibles(plantas);
        
        const tipos = [...new Set(habitacionesParaMostrar.map(h => 
          h.descrip || h.tipo || 'Standard'
        ).filter(Boolean))].sort();
        
        setTiposHabitacionDisponibles(tipos);
        
      } else {
        console.error('Respuesta no exitosa:', response.data);
        message.error('Error en la respuesta del servidor');
      }
    } catch (error) {
      // console.log('Error cargando habitaciones disponibles:', error);
      message.error('Error al cargar habitaciones disponibles');
    } finally {
      setCargandoHabitacionesDisponibles(false);
    }
  };

const cerrarDrawerAsignacion = () => {
  setModalAsignarVisible(false);
  // No limpiamos la línea seleccionada para poder seguir trabajando
};

const asignarHabitacion = async (numHabitacion) => {
    if (!lineaSeleccionadaAsignacion || !currentReserva) return;
    
    setCargandoAsignacion(true);
    try {
      const token = localStorage.getItem('token');
      
      const response = await axios.put(
        `${BASE_URL}/api/reservas/${currentReserva.NumReserva}/asignar-habitacion`,
        {
          linea: lineaSeleccionadaAsignacion.Linea,
          numHabitacion: numHabitacion,
          aplicarATodaHabitacion: true
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      if (response.data.success) {
        message.success({
          content: `✅ Habitación ${numHabitacion} asignada`,
          duration: 1,
        });

        // Actualizar tabla localmente
        const lineasActualizadas = filteredEntradas.map(l => {
          if (l.linea === lineaSeleccionadaAsignacion.Linea && 
              l.numreserva === currentReserva.NumReserva) {
            return { ...l, numhab: numHabitacion, numhab2: numHabitacion };
          }
          return l;
        });

        setFilteredEntradas(lineasActualizadas);
        
        // Actualizar la línea seleccionada
        setLineaSeleccionadaAsignacion(prev => ({
          ...prev,
          NumHab: numHabitacion
        }));
        
        // Si hay más registros, preguntar si quiere avanzar
        if (registrosFiltradosActuales.length > 1) {
          Modal.confirm({
            title: '¿Continuar con el siguiente registro?',
            content: `Habitación asignada correctamente. ¿Deseas pasar al siguiente registro sin habitación?`,
            okText: 'Sí, siguiente',
            cancelText: 'No, quedarme aquí',
            onOk: () => {
              navegarRegistro('siguiente');
            }
          });
        }
      }
    } catch (error) {
      // console.log('Error asignando habitación:', error);
      message.error(error.response?.data?.error || 'Error al asignar la habitación');
    } finally {
      setCargandoAsignacion(false);
    }
  };

const desasignarHabitacion = async () => {
    if (!lineaSeleccionadaAsignacion || !currentReserva) return;
    
    setCargandoAsignacion(true);
    try {
      const token = localStorage.getItem('token');
      
      const response = await axios.put(
        `${BASE_URL}/api/reservas/${currentReserva.NumReserva}/desasignar-habitacion`,
        {
          linea: lineaSeleccionadaAsignacion.Linea,
          aplicarATodaHabitacion: true
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      if (response.data.success) {
        message.success('Habitación desasignada correctamente');
        
        // Actualizar tabla localmente
        const lineasActualizadas = filteredEntradas.map(l => {
          if (l.linea === lineaSeleccionadaAsignacion.Linea && 
              l.numreserva === currentReserva.NumReserva) {
            return { ...l, numhab: null, numhab2: null };
          }
          return l;
        });

        setFilteredEntradas(lineasActualizadas);
        
        // Recargar habitaciones disponibles
        cargarHabitacionesDisponibles(lineaSeleccionadaAsignacion, currentReserva);
      }
    } catch (error) {
      console.error('Error desasignando habitación:', error);
      message.error(error.response?.data?.error || 'Error al desasignar la habitación');
    } finally {
      setCargandoAsignacion(false);
    }
  };

  const habitacionesFiltradas = habitacionesDisponibles.filter(habitacion => {
    // Filtro por texto de búsqueda
    if (filtroBusquedaHabitaciones) {
      const busqueda = filtroBusquedaHabitaciones.toLowerCase();
      const numHabitacion = String(habitacion.numhabitacio || habitacion.NumHab || '').toLowerCase();
      const tipoHabitacion = String(habitacion.tipo || '').toLowerCase();
      
      if (!numHabitacion.includes(busqueda) && !tipoHabitacion.includes(busqueda)) {
        return false;
      }
    }
    
    // Filtro por planta
    if (filtroPlanta !== null) {
      const plantaHabitacion = habitacion.planta || Math.floor((habitacion.numhabitacio || habitacion.NumHab || 0) / 100);
      if (plantaHabitacion !== filtroPlanta) {
        return false;
      }
    }
    
    // Filtro por tipo
    if (filtroTipo !== null && habitacion.tipo !== filtroTipo) {
      return false;
    }
    
    return true;
  });

  
  
//  const PanelNavegacion = () => {
//     if (!registrosFiltradosActuales.length) return null;
    
//     const totalRegistros = registrosFiltradosActuales.length;
//     const registroActual = registrosFiltradosActuales[indiceRegistroActual];
    
//     return (
//       <div style={{ 
//         display: 'flex', 
//         alignItems: 'center', 
//         justifyContent: 'space-between',
//         marginBottom: 16,
//         padding: '12px',
//         backgroundColor: '#f0f8ff',
//         borderRadius: '8px',
//         border: '1px solid #1890ff33'
//       }}>
//         <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//           {/* <Button
//             icon={<CaretLeftOutlined />}
//             size="small"
//             onClick={() => navegarRegistro('anterior')}
//             disabled={totalRegistros <= 1}
//           /> */}
          
//           <div style={{ minWidth: '180px', textAlign: 'center' }}>
//             {/* <Text strong>
//               {indiceRegistroActual + 1} / {totalRegistros}
//             </Text> */}
//             <div style={{ fontSize: '12px', color: '#666' }}>
//               {registroActual?.nombre?.split(' ')[0] || 'Sin nombre'}
//             </div>
//           </div>
          
//           {/* <Button
//             icon={<CaretRightOutlined />}
//             size="small"
//             onClick={() => navegarRegistro('siguiente')}
//             disabled={totalRegistros <= 1}
//           /> */}
//         </div>
        
//         <div style={{ textAlign: 'right' }}>
//           <Space>
//             <Tag color="blue">#{registroActual?.numreserva}</Tag>
//             <Tag color="blue">Línea {registroActual?.linea}</Tag>
//           </Space>
//         </div>
//       </div>
//     );
//   };

  // Componente del panel de asignación
  const PanelAsignacion = () => (
    <div
      style={{
        position: 'fixed',
        top: 0,
        right: 0,
        width: `${panelAncho}px`,
        height: '100vh',
        backgroundColor: '#fff',
        boxShadow: '-4px 0 16px rgba(0, 0, 0, 0.1)',
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        transition: estaRedimensionando ? 'none' : 'width 0.2s ease'
      }}
    >
      {/* Barra de redimensionamiento */}
      <div
        ref={resizeRef}
        style={{
          position: 'absolute',
          left: '-5px',
          top: 0,
          width: '10px',
          height: '100%',
          cursor: 'col-resize',
          zIndex: 1001,
          backgroundColor: 'transparent'
        }}
        onMouseDown={(e) => {
          e.preventDefault();
          setEstaRedimensionando(true);
          setPanelPosicion(e.clientX);
        }}
      />
      
      {/* Header del panel */}
      <div style={{
        padding: '16px 24px',
        borderBottom: '1px solid #f0f0f0',
        backgroundColor: '#fafafa',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <Space>
          <KeyOutlined style={{ color: '#1890ff' }} />
          <Text strong>Asignación de Habitaciones</Text>
        </Space>
        <Space>
          <Tooltip title="Ocultar panel">
            <Button
              type="text"
              icon={<DoubleRightOutlined />}
              size="small"
              onClick={() => setPanelAsignacionVisible(false)}
            />
          </Tooltip>
        </Space>
      </div>
      
      {/* Contenido del panel */}
      <div style={{
        flex: 1,
        overflow: 'auto',
        padding: '24px'
      }}>
        {/* Navegación entre registros */}
        {/* <PanelNavegacion /> */}
        
        {/* Información de la reserva */}
        {lineaSeleccionadaAsignacion && currentReserva ? (
          <>
            <Card size="small" style={{ marginBottom: 16 }}>
              <Descriptions size="small" column={1}>
                <Descriptions.Item label="Cliente">
                  <Text strong>{currentReserva.Nombre}</Text>
                </Descriptions.Item>
                <Descriptions.Item label="Reserva">
                  <Tag color="blue">#{currentReserva.NumReserva}</Tag>
                  <Tag color="blue">Línea {lineaSeleccionadaAsignacion.Linea}</Tag>                
                </Descriptions.Item>
                <Descriptions.Item label="Estancia">
                  <Space>
                    <CalendarOutlined style={{ color: '#666' }} />
                    <Text>
                      {dayjs(lineaSeleccionadaAsignacion.Entrada).format('DD/MM/YYYY')}
                      {' → '}
                      {dayjs(lineaSeleccionadaAsignacion.Salida).format('DD/MM/YYYY')}
                    </Text>
                  </Space>
                </Descriptions.Item>
                <Descriptions.Item label="Habitación Actual">
                  {lineaSeleccionadaAsignacion.NumHab ? (
                    <Space>
                      <Tag color="green" style={{ fontSize: '14px', padding: '2px 8px' }}>
                        {lineaSeleccionadaAsignacion.NumHab}
                      </Tag>
                      <Button
                        type="text"
                        danger
                        size="small"
                        icon={<CloseOutlined />}
                        onClick={desasignarHabitacion}
                        loading={cargandoAsignacion}
                      >
                        Desasignar
                      </Button>
                    </Space>
                  ) : (
                    <Tag color="orange">Sin asignar</Tag>
                  )}
                </Descriptions.Item>
              </Descriptions>
            </Card>
            
            {/* Filtros de habitaciones */}
            <Card size="small" style={{ marginBottom: 16 }}>
              <Space direction="vertical" style={{ width: '100%' }}>
                <Input.Search
                  placeholder="Buscar habitación..."
                  value={filtroBusquedaHabitaciones}
                  onChange={(e) => setFiltroBusquedaHabitaciones(e.target.value)}
                  allowClear
                  style={{ width: '100%' }}
                />
                
                <Row gutter={8}>
                  <Col span={12}>
                    <Select
                      placeholder="Filtrar por planta"
                      style={{ width: '100%' }}
                      value={filtroPlanta}
                      onChange={setFiltroPlanta}
                      allowClear
                    >
                      {plantasDisponibles.map(planta => (
                        <Option key={planta} value={planta}>
                          Planta {planta}
                        </Option>
                      ))}
                    </Select>
                  </Col>
                  <Col span={12}>
                    <Select
                      placeholder="Filtrar por tipo"
                      style={{ width: '100%' }}
                      value={filtroTipo}
                      onChange={setFiltroTipo}
                      allowClear
                    >
                      {tiposHabitacionDisponibles.map(tipo => (
                        <Option key={tipo} value={tipo}>
                          {tipo}
                        </Option>
                      ))}
                    </Select>
                  </Col>
                </Row>
              </Space>
            </Card>
            
            {/* Lista de habitaciones disponibles */}
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
                <Text strong>
                  Habitaciones Disponibles ({habitacionesFiltradas.length})
                </Text>
                <Text type="secondary">
                  {cargandoHabitacionesDisponibles ? 'Cargando...' : ''}
                </Text>
              </div>
              
              {cargandoHabitacionesDisponibles ? (
                <div style={{ padding: '20px', textAlign: 'center' }}>
                  <Skeleton active />
                </div>
              ) : habitacionesFiltradas.length === 0 ? (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={
                    filtroBusquedaHabitaciones || filtroPlanta !== null || filtroTipo !== null
                      ? "No hay habitaciones con esos filtros"
                      : "No hay habitaciones disponibles"
                  }
                />
              ) : (
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))',
                  gap: '8px',
                  maxHeight: 'calc(100vh - 400px)',
                  overflowY: 'auto',
                  padding: '8px'
                }}>
                  {habitacionesFiltradas.map(habitacion => (
                    <Card
                      key={habitacion.numhabitacio || habitacion.NumHab}
                      size="small"
                      hoverable
                      style={{
                        textAlign: 'center',
                        cursor: 'pointer',
                        border: `2px solid ${habitacion.Estado==1 ? '#d9f7be' : '#ffccc7'}`,
                        backgroundColor: habitacion.Estado==1 ? '#f6ffed' : '#fff2f0',
                        transition: 'all 0.2s'
                      }}
                      onClick={() => habitacion.disponible && asignarHabitacion(habitacion.numhabitacio || habitacion.NumHab)}
                      onMouseEnter={(e) => {
                        if (habitacion.disponible) {
                          e.currentTarget.style.transform = 'translateY(-2px)';
                          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (habitacion.disponible) {
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = 'none';
                        }
                      }}
                    >
                      <div style={{ 
                        fontSize: '20px', 
                        fontWeight: 'bold', 
                        marginBottom: '4px',
                        color: habitacion.disponible ? '#389e0d' : '#cf1322'
                      }}>
                        {habitacion.numhabitacio || habitacion.NumHab}
                      </div>
                      <div style={{ fontSize: '11px', color: '#666', marginBottom: '4px' }}>
                        Planta {habitacion.planta || 'N/A'} 
                      </div>
                      <div style={{ fontSize: '11px', color: '#666' }}>
                        {habitacion.tipo || 'Standard'}
                      </div>
                      {/* <div style={{ marginTop: '4px' }}>
                        {habitacion.disponible ? (
                          <Tag color="success" style={{ fontSize: '10px', padding: '0 4px' }}>
                            Libre
                          </Tag>
                        ) : (
                          <Tag color="error" style={{ fontSize: '10px', padding: '0 4px' }}>
                            Ocupada
                          </Tag>
                        )}
                      </div> */}
                    </Card>
                  ))}
                </div>
              )}
            </div>
          </>
        ) : (
          <div style={{ textAlign: 'center', padding: '40px 20px' }}>
            <Empty
              description="Selecciona un registro para asignar habitación"
            />
          </div>
        )}
      </div>
      
      {/* Footer del panel */}
      <div style={{
        padding: '12px 24px',
        borderTop: '1px solid #f0f0f0',
        backgroundColor: '#fafafa',
        textAlign: 'center'
      }}>
        <Text type="secondary">
          {registrosFiltradosActuales.length} registros sin habitación
        </Text>
      </div>
    </div>
  );

  // Estadísticas
  const getEstadisticas = () => {
    const statsEntradas = {
      total: entradas.length,
      conCheckin: entradas.filter(item => item.entro === true).length,
      sinCheckin: entradas.filter(item => item.entro === false).length,
      conHabitacion: entradas.filter(item => item.numhab2 && item.numhab2 !== '').length,
      sinHabitacion: entradas.filter(item => !item.numhab2 || item.numhab2 === '').length
    };
    
    const statsSalidas = {
      total: salidas.length,
      conCheckout: salidas.filter(item => item.salio === true).length,
      sinCheckout: salidas.filter(item => item.salio === false).length,
      conHabitacion: salidas.filter(item => item.numhab2 && item.numhab2 !== '').length,
      sinHabitacion: salidas.filter(item => !item.numhab2 || item.numhab2 === '').length
    };
    
    return { entradas: statsEntradas, salidas: statsSalidas };
  };

  const estadisticas = getEstadisticas();

  
  const estadisticasComponent = (
    <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
      {/* Estadísticas Entradas */}
      <Col span={12}>
        <Card 
          title={
            <Space>
              <CalendarOutlined />
              <span>Entradas - {fechaSeleccionada.format('DD/MM/YYYY')}</span>
            </Space>
          }
          size="small"
          style={{ height: '100%' }}
        >
          <Row gutter={[8, 8]}>
            <Col span={12}>
              <Statistic 
                title="Total" 
                value={estadisticas.entradas.total}
                valueStyle={{ color: '#1890ff' }}
              />
            </Col>
            <Col span={12}>
              <Statistic 
                title="Checkin Realizado" 
                value={estadisticas.entradas.conCheckin}
                valueStyle={{ color: '#52c41a' }}
              />
            </Col>
            <Col span={12}>
              <Statistic 
                title="Pendiente Checkin" 
                value={estadisticas.entradas.sinCheckin}
                valueStyle={{ color: '#fa8c16' }}
              />
            </Col>
            <Col span={12}>
              <Statistic 
                title="Sin Habitación" 
                value={estadisticas.entradas.sinHabitacion}
                valueStyle={{ color: '#f5222d' }}
              />
            </Col>
          </Row>
        </Card>
      </Col>
      
      {/* Estadísticas Salidas */}
      <Col span={12}>
        <Card 
          title={
            <Space>
              <ClockCircleOutlined />
              <span>Salidas - {fechaSeleccionada.format('DD/MM/YYYY')}</span>
            </Space>
          }
          size="small"
          style={{ height: '100%' }}
        >
          <Row gutter={[8, 8]}>
            <Col span={12}>
              <Statistic 
                title="Total" 
                value={estadisticas.salidas.total}
                valueStyle={{ color: '#1890ff' }}
              />
            </Col>
            <Col span={12}>
              <Statistic 
                title="Checkout Realizado" 
                value={estadisticas.salidas.conCheckout}
                valueStyle={{ color: '#52c41a' }}
              />
            </Col>
            <Col span={12}>
              <Statistic 
                title="Pendiente Checkout" 
                value={estadisticas.salidas.sinCheckout}
                valueStyle={{ color: '#fa8c16' }}
              />
            </Col>
            <Col span={12}>
              <Statistic 
                title="Con Habitación" 
                value={estadisticas.salidas.conHabitacion}
                valueStyle={{ color: '#13c2c2' }}
              />
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );

  const searchBar = (
    <div style={{ marginBottom: 16 }}>
      <Row gutter={[16, 16]} align="middle">
        <Col span={8}>
          <Space>
            {/* Navegación de fecha */}
            <Button.Group>
              <Tooltip title="Semana anterior">
                <Button 
                  icon={<DoubleLeftOutlined />} 
                  onClick={() => setFechaSeleccionada(fechaSeleccionada.clone().subtract(1, 'week'))}
                />
              </Tooltip>
              <Tooltip title="Día anterior">
                <Button 
                  icon={<LeftOutlined />} 
                  onClick={() => setFechaSeleccionada(fechaSeleccionada.clone().subtract(1, 'day'))}
                />
              </Tooltip>
              
              <DatePicker
                value={fechaSeleccionada}
                onChange={(date) => setFechaSeleccionada(date || dayjs())}
                format="DD/MM/YYYY"
                style={{ width: 150 }}
                allowClear={false}
              />

            <Tooltip title="Hoy">
                <Button 
                  onClick={() => setFechaSeleccionada(dayjs())}
                >
                  Hoy
                </Button>
              </Tooltip>    
              
              <Tooltip title="Día siguiente">
                <Button 
                  icon={<RightOutlined />} 
                  onClick={() => setFechaSeleccionada(fechaSeleccionada.clone().add(1, 'day'))}
                />
              </Tooltip>
              <Tooltip title="Semana siguiente">
                <Button 
                  icon={<DoubleRightOutlined />} 
                  onClick={() => setFechaSeleccionada(fechaSeleccionada.clone().add(1, 'week'))}
                />
              </Tooltip>
            </Button.Group>

            {/* Botón de actualización
            <Button
              icon={<ReloadOutlined />}
              onClick={fetchData}
              loading={tableLoading}
            >
              Actualizar
            </Button> */}
          </Space>
        </Col>
        <Col span={8}>
          <Input.Search
            placeholder="Buscar por nombre, agencia, localizador..."
            value={globalSearchText}
            style={{ width: '100%' }}
            allowClear
            enterButton
            onChange={(e) => {
              setGlobalSearchText(e.target.value);
              if (e.target.value === '') {
                handleGlobalSearch('');
              }
            }}
            onSearch={handleGlobalSearch}
          />
        </Col>
        
        <Col span={8} style={{ textAlign: 'right' }}>
          <Space>
            {/* Botón de acciones masivas */}
            {activeTab === 'entradas' ? (
              <Popconfirm
                title={`¿Realizar checkin a TODAS las líneas con habitación?`}
                description={`Se realizará checkin a ${filteredEntradas.filter(r => r.numhab2 && !r.entro).length} líneas pendientes con habitación asignada.`}
                onConfirm={handleCheckinMasivo}                
                okText="Sí, hacer checkin"
                cancelText="Cancelar"
                disabled={filteredEntradas.filter(r => r.numhab2 && !r.entro).length === 0}
              >
                <Button
                  type="primary"
                  icon={<CheckCircleOutlined />}
                  loading={loading}
                  disabled={filteredEntradas.filter(r => r.numhab2 && !r.entro).length === 0}
                >
                  Checkin Masivo ({filteredEntradas.filter(r => r.numhab2 && !r.entro).length})
                </Button>
              </Popconfirm>
            ) : (
              <Popconfirm
                title={`¿Realizar checkout a TODAS las líneas?`}
                description={`Se realizará checkout a ${filteredSalidas.filter(r => !r.salio).length} líneas pendientes.`}
                onConfirm={handleCheckoutMasivo}
                okText="Sí, hacer checkout"
                cancelText="Cancelar"
                disabled={filteredSalidas.filter(r => !r.salio).length === 0}
              >
                <Button
                  type="primary"
                  danger
                  icon={<LogoutOutlined />}
                  loading={loading}
                  disabled={filteredSalidas.filter(r => !r.salio).length === 0}
                >
                  Checkout Masivo ({filteredSalidas.filter(r => !r.salio).length})
                </Button>
              </Popconfirm>
            )}
            
            <Tag color="blue" style={{ fontSize: 14, padding: '4px 12px', borderRadius: 20 }}>
              <strong>
                {activeTab === 'entradas' ? filteredEntradas.length : filteredSalidas.length}
              </strong> registros
            </Tag>
          </Space>
        </Col>

        <Col span={8} style={{ textAlign: 'right' }}>
          <Space>
            <Tag color="blue" style={{ fontSize: 14, padding: '4px 12px', borderRadius: 20 }}>
              <strong>
                {activeTab === 'entradas' ? filteredEntradas.length : filteredSalidas.length}
              </strong> registros
            </Tag>
          </Space>
        </Col>
      </Row>
    </div>
  );

  return (
    <>
      <PageContainer
        title="Checkin / Checkout"
        subtitle={`Gestión de entradas y salidas - ${fechaSeleccionada.format('DD/MM/YYYY')}`}
        icon={<KeyOutlined />}
        loading={loading}
        onRefresh={fetchData}
        badgeCount={entradas.length + salidas.length}
        badgeStatus="processing"
        cardStyle={{
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
          marginRight: panelAsignacionVisible ? `${panelAncho}px` : '0',
          transition: 'margin-right 0.2s ease'          
        }}
      >
        {/* Estadísticas */}
        {estadisticasComponent}

        {/* Selector de fecha y búsqueda */}
        {searchBar}
        
        {/* Tabs de Entradas/Salidas */}
        <Tabs 
          activeKey={activeTab} 
          onChange={setActiveTab}
          type="card"
          style={{ marginBottom: 16 }}
        >
          <TabPane 
            tab={
              <span>
                <CalendarOutlined />
                Entradas ({entradas.length})
                <Badge 
                  count={filteredEntradas.filter(r => !r.numhab2).length} 
                  style={{ marginLeft: 8, backgroundColor: '#fa8c16' }} 
                />
              </span>
            } 
            key="entradas"
          >
            <Table
              columns={columnasEntradas}
              dataSource={filteredEntradas}
              rowKey={(record) => `${record.numreserva}-${record.linea}`}
              loading={tableLoading}
              scroll={{ x: 1500 }}
              style={{
                borderRadius: '8px',
                overflow: 'hidden'
              }}
        //   onRow={(record) => ({
        //         onDoubleClick: () => handleVerDetalle(record),
        //       })}              
            />
          </TabPane>
          
          <TabPane 
            tab={
              <span>
                <ClockCircleOutlined />
                Salidas ({salidas.length})
              </span>
            } 
            key="salidas"
          >
            <Table
              columns={columnasSalidas}
              dataSource={filteredSalidas}
              rowKey={(record) => `${record.numreserva}-${record.linea}`}
              loading={tableLoading}
              scroll={{ x: 1500 }}
              style={{
                borderRadius: '8px',
                overflow: 'hidden'
              }}
            />
          </TabPane>
        </Tabs>
      </PageContainer>

      {/* Panel de asignación lateral */}
      {panelAsignacionVisible && <PanelAsignacion />}
      
      {/* Botón flotante */}
      {/* <FloatButtonPanel />       */}

      {/* Modal de detalle de ocupantes */}
      <Modal
        title={
          <Space>
            <TeamOutlined />
            <span>
              Detalle de Habitación - Reserva #{currentRegistro?.numreserva}, Línea {currentRegistro?.linea}
            </span>
          </Space>
        }
        open={modalDetalleVisible}
        onCancel={() => setModalDetalleVisible(false)}
        width={800}
        footer={[
          <Button key="close" onClick={() => setModalDetalleVisible(false)}>
            Cerrar
          </Button>
        ]}
      >
        {ocupantes.length > 0 ? (
          <div style={{ marginTop: 20 }}>
            {/* Información general */}
            <Card size="small" style={{ marginBottom: 16 }}>
              <Descriptions size="small" column={3}>
                <Descriptions.Item label="Habitación">
                  <Tag color="green">{currentRegistro?.numhab2 || 'Sin asignar'}</Tag>
                </Descriptions.Item>
                <Descriptions.Item label="Tipo Hab.">
                  <Tag color={getTipoHabDesc(currentRegistro?.tipohab).color}>
                    {getTipoHabDesc(currentRegistro?.tipohab).text}
                  </Tag>
                </Descriptions.Item>
                <Descriptions.Item label="Régimen">
                  {currentRegistro?.regimen}
                </Descriptions.Item>
                <Descriptions.Item label="Checkin">
                  {currentRegistro?.entro === true ? (
                    <Badge status="success" text="Realizado" />
                  ) : (
                    <Badge status="warning" text="Pendiente" />
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="Checkout">
                  {currentRegistro?.salio === true ? (
                    <Badge status="success" text="Realizado" />
                  ) : (
                    <Badge status="warning" text="Pendiente" />
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="Agencia">
                  {currentRegistro?.nomagencia}
                </Descriptions.Item>
              </Descriptions>
            </Card>
            
            {/* Lista de ocupantes */}
            <Collapse defaultActiveKey={['1']}>
              <Panel header={`Ocupantes (${ocupantes.length})`} key="1">
                <List
                  dataSource={ocupantes}
                  renderItem={(ocupante) => (
                    <List.Item
                      key={ocupante.Numocupante}
                      actions={[
                        <Tooltip title={ocupante.Entro === true ? 'Checkin realizado' : 'Pendiente checkin'}>
                          <Badge 
                            status={ocupante.Entro === true ? 'success' : 'default'} 
                            text={ocupante.Entro === true ? '✓' : ''}
                          />
                        </Tooltip>,
                        <Tooltip title={ocupante.Salio === true ? 'Checkout realizado' : 'Pendiente checkout'}>
                          <Badge 
                            status={ocupante.Salio === true ? 'success' : 'default'} 
                            text={ocupante.Salio === true ? '✓' : ''}
                          />
                        </Tooltip>
                      ]}
                    >
                      <List.Item.Meta
                        avatar={
                          <Avatar 
                            style={{ 
                              backgroundColor: ocupante.Entro === true ? '#52c41a' : '#fa8c16' 
                            }}
                          >
                            {ocupante.Numocupante}
                          </Avatar>
                        }
                        title={
                          <Space>
                            <Text strong>{ocupante.Nombre}</Text>
                            <Tag size="small">
                              {getTipoFacDesc(ocupante.TipoFac)}
                            </Tag>
                          </Space>
                        }
                        description={
                          <Space direction="vertical" size={0}>
                            <Text type="secondary">
                              Particular: {ocupante.nombreParticular || 'No asignado'}
                            </Text>
                            <Text type="secondary">
                              Tipo cliente: {ocupante.TipoCliente || 'RECE'}
                            </Text>
                          </Space>
                        }
                      />
                    </List.Item>
                  )}
                />
              </Panel>
            </Collapse>
          </div>
        ) : (
          <div style={{ textAlign: 'center', padding: '40px 0' }}>
            <Text type="secondary">No se encontraron ocupantes</Text>
          </div>
        )}
      </Modal>

      {/* Modal de asignación de habitación */}
      {/* <AsignarHabitacionModal
        visible={modalAsignarVisible}
        onCancel={() => setModalAsignarVisible(false)}
        onConfirm={handleAsignarHabitacionConfirm}
        registro={currentRegistro}
      /> */}

        {/* <AsignacionHabitacionesDrawer
            drawerAsignacionVisible={modalAsignarVisible}
            onClose={() => setModalAsignarVisible(false)}

            lineaSeleccionadaAsignacion={lineaSeleccionadaAsignacion}
            habitacionesDisponibles={habitacionesDisponibles}
            // habitacionAsignada={habitacionAsignada}
            cargandoAsignacion={cargandoAsignacion}
            asignarHabitacion={asignarHabitacion}            
            plantasDisponibles={plantasDisponibles}
            tiposHabitacionDisponibles={tiposHabitacionDisponibles}
            cargandoHabitacionesDisponibles={cargandoHabitacionesDisponibles}
            desasignarHabitacion={desasignarHabitacion}
            cerrarDrawerAsignacion={cerrarDrawerAsignacion}
          />       */}

<AsignacionHabitacionesDrawer
        drawerAsignacionVisible={modalAsignarVisible}
        onClose={() => setModalAsignarVisible(false)}
        lineaSeleccionadaAsignacion={lineaSeleccionadaAsignacion}
        habitacionesDisponibles={habitacionesDisponibles}
        cargandoAsignacion={cargandoAsignacion}
        asignarHabitacion={asignarHabitacion}            
        plantasDisponibles={plantasDisponibles}
        tiposHabitacionDisponibles={tiposHabitacionDisponibles}
        cargandoHabitacionesDisponibles={cargandoHabitacionesDisponibles}
        desasignarHabitacion={desasignarHabitacion}
        cerrarDrawerAsignacion={cerrarDrawerAsignacion}
        modoNavegacion={modoAsignacion === 'modal'}
        onSiguienteRegistro={() => navegarRegistro('siguiente')}
        onRegistroAnterior={() => navegarRegistro('anterior')}
        registroActual={indiceRegistroActual + 1}
        totalRegistros={registrosFiltradosActuales.length}
      />          
  <ModalLineas
    visible={modalLineasVisible}
    onClose={() => setModalLineasVisible(false)}
    numReserva={reservaSeleccionada?.numReserva}
    linea={reservaSeleccionada?.linea}
    nombreCliente={reservaSeleccionada?.nombre}
    codigoHotel={reservaSeleccionada?.codigoHotel}
  />            

      {renderModalAsignacionRapida()}

      {/* {renderFloatButton()} */}
    </>
  );
};

export default CheckinCheckout;